<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="restrictionsPromise" />
    <Placy
      v-if="!restrictions.length"
      :promise="restrictionsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('RESTRICTION', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('RESTRICTION', 2) }) })"
    />

    <router-link class="item" :to="{ name: 'new-restriction' }">
      <i class="plus icon" />
      <strong>{{ $t('NEW', { thing: $tc('RESTRICTION', 1) }) }}</strong>
    </router-link>

    <router-link
      v-for="restriction in restrictionsWithGroupNames"
      :key="restriction.id"
      class="item"
      :active-class="'active'"
      :to="{ name: 'restriction', params: { restrictionId: restriction.id } }"
    >
      <div class="content" :title="restriction.group">
        <div class="group ellipsis" :title="restriction.forGroupName">
          {{ restriction.forGroupName }}
        </div>
        <div class="version" :title="restriction.forVersion">
          {{ restriction.forVersion }}
        </div>
      </div>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}

.group {
  font-weight: bold;
  margin-bottom: 0.5em;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Spinny, Placy } from 'ui'
import Vue from 'vue'
import { Restrictions, Toast, Typenames, Group } from 'services'
import { map, catchError } from 'rxjs/operators'
import { ActionTypes } from 'store'
import fuzzy from 'fuzzy'

export default {
  name: 'restriction-list',
  components: { Spinny, Placy },

  data() {
    return {
      restrictionsPromise: null
    }
  },

  computed: {
    restrictions() {
      return this.$store.state.flow_restrictions.items
    },
    groups() {
      return this.$store.state.group.items
    },
    restrictionsWithGroupNames() {
      return _.map(this.restrictions, r => {
        const group = _.find(this.groups, g => g.id === r.forGroup)
        return {
          forGroupName: group ? group.name : r.forGroup,
          ...r
        }
      })
    }
  },

  created() {
    this.restrictionsPromise = Promise.all([Group.readAllGroups(), Restrictions.readAll()])
  }
}
</script>
